import { useEffect, useState } from 'react'
import { useAppDispatch } from '@/utils/typeHelpers'

import { Button, Card, CardColors, Text, Image, Toggle } from '@/ui'
import EstimateBreakdownV3 from './estimate-breakdown-v3'
import { useReselector } from '@/utils/sharedHooks'
import { selectSampleTaxCalculation } from '@/selectors/userTaxCalculation.selectors'
import { selectActiveQuarterlyTaxEstimateDetails } from '@/features/admin/quarterly-tax-estimate-details/quarterlyTaxEstimateDetails.selector'
import { fetchAllQuarterlyTaxEstimateDetailsIfNeeded } from '@/features/admin/quarterly-tax-estimate-details/quarterlyTaxEstimateDetails.slice'
import { useNavigate } from 'react-router-dom'
import { TypographyStyles } from '@/styles'

export const EstimateBreakdownSample = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [showSampleData, setShowSampleData] = useState(false)

  const sampleCalculation = useReselector(selectSampleTaxCalculation)

  const taxCalc = showSampleData ? sampleCalculation : undefined
  const estimateDetails = useReselector(selectActiveQuarterlyTaxEstimateDetails)

  useEffect(() => {
    dispatch(fetchAllQuarterlyTaxEstimateDetailsIfNeeded())
  }, [dispatch])

  return (
    <>
      {showSampleData && (
        <div className="sticky top-0 bg-yellow-100 px-4 py-2 text-center font-medium z-50">
          This is a <b>demo</b> page using <b>sample data</b>.
        </div>
      )}

      <div className="flex flex-col space-y-6 mx-4 md:mx-0">
        <Card color={CardColors.LEVEL_1} className="p-4">
          <div className="flex flex-col md:flex-row items-center md:space-x-6">
            {/* Illustration */}
            <div className="flex justify-center mb-4 md:mb-0">
              <Image
                src="https://heard-images.s3.amazonaws.com/assets/calculator2.svg"
                alt="Tax Calculator"
                width={44}
                height={44}
              />
            </div>

            {/* Content */}
            <div className="flex-1 flex flex-col space-y-4">
              <Text variant={TypographyStyles.H2}>
                You don’t have a quarterly tax estimate yet
              </Text>
              <Text>
                Get yours to receive a personalized breakdown. It will show how
                your income and tax payments affect your quarterly tax estimate.
              </Text>

              <label className="flex items-center space-x-2">
                <span className="text-sm font-medium text-gray-700">
                  View with sample data
                </span>
                <Toggle
                  id="notify-toggle"
                  checked={showSampleData}
                  onChange={() => setShowSampleData(!showSampleData)}
                />
              </label>
              <Button onClick={() => navigate('/taxes/quarterly')}>
                Get My Tax Estimate
              </Button>
            </div>
          </div>
        </Card>

        {/* Estimate Breakdown */}
        <EstimateBreakdownV3
          taxCalc={taxCalc}
          estimateDetails={estimateDetails}
          isSample
        />
      </div>
    </>
  )
}
